function random() {
  //随机生成aes密钥
  let arr=['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f'];
  let _key='';
  for (let i=0;i<16;i++){
    _key+=arr[Math.floor(Math.random()*16)]
  }
  return _key;
}
export default random;



// WEBPACK FOOTER //
// ./src/modules/utils/random.js